<template>
  <div id="goods">
    <div class="comond_btn">
      <el-button @click="dialogVisible = true">添加退货地址</el-button>
    </div>
    <template>
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="地址简称" prop="addressName"></el-table-column>
        <el-table-column label="收件人名字" prop="name"></el-table-column>
        <el-table-column label="收件人手机" prop="phone"></el-table-column>
        <el-table-column label="省" prop="province"></el-table-column>
        <el-table-column label="市" prop="city"></el-table-column>
        <el-table-column label="区" prop="region"></el-table-column>
        <el-table-column label="详细地址" prop="detailAddress"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 添加店铺dialog -->
    <div>
      <el-dialog
        title="添加退货地址"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="地址简称" prop="addressName" :labelWidth="formLabelWidth">
            <el-input placeholder="请输入地址简称" v-model="form.addressName" clearable></el-input>
          </el-form-item>
          <el-form-item label="收件人名字" prop="name" :labelWidth="formLabelWidth">
            <el-input placeholder="请输入收件人名字" v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="收件人手机" prop="phone" :labelWidth="formLabelWidth">
            <el-input placeholder="请输入收件人手机" v-model="form.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="请选择省市区" prop="selectedOptions" :labelWidth="formLabelWidth">
            <el-cascader
              :options="areaSelectData"
              @change="handleChange"
              size="large"
              v-model="form.selectedOptions"
              placeholder="请选择您所在的城市"
            />
          </el-form-item>
          <el-form-item label="详细地址" prop="detailAddress" :labelWidth="formLabelWidth">
            <el-input placeholder="请输入详细地址" v-model="form.detailAddress" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handCancer()">取 消</el-button>
          <el-button type="primary" @click="handleSave('form')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 编辑店铺dialog -->
    <div>
      <el-dialog
        title="编辑店铺"
        :visible.sync="editDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="ruleForm">
          <el-form-item label="店铺名称" :labelWidth="formLabelWidth">
            <el-input v-model="ruleForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="首字母" :labelWidth="formLabelWidth">
            <el-input v-model="ruleForm.firstLetter" clearable></el-input>
          </el-form-item>
          <el-form-item label="品牌介绍" :labelWidth="formLabelWidth">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="ruleForm.brandStoryText"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleEditSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看店铺dialog -->
    <div>
      <el-dialog title="店铺详情" :visible.sync="detaildialogVisible" width="50%">
        <!-- 详情内容 -->
        <el-descriptions class="margin-top" title :column="2" :size="size" border>
          <el-descriptions-item>
            <template slot="label">地址简称</template>
            {{detailData.addressName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">收件人名字</template>
            {{detailData.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">收件人手机</template>
            {{detailData.phone}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">省</template>
            {{detailData.province}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">市</template>
            {{detailData.city}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">区</template>
            {{detailData.region}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">详细地址</template>
            {{detailData.detailAddress}}
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
import { queryListAddress, addAddress, deleteAddress, updateBrand } from '../../api'
export default {
  data () {
    return {
      areaSelectData: regionData, // 省市区不带‘全部’三级联动选择
      rules: {
        addressName: [
          { required: true, message: '请输入地址简称', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入收件人名字', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入收件人手机', trigger: 'blur' },
        ],
        selectedOptions: [
          { required: true, message: '请选择省市区', trigger: 'change' },
        ],
        detailAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
      },
      size: '',
      detailData: [],
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      formLabelWidth: '160px',
      // 添加默认关闭弹框
      dialogVisible: false,
      // 详情弹框
      detaildialogVisible: false,
      // 编辑弹框
      editDialogVisible: false,
      // 查询
      search: '',
      // 列表数据
      tableData: [],
      // 初始化
      form: {
        addressName: '',
        name: '',
        phone: '',
        provinceCode: '',
        cityCode: '',
        orgion: '',
        selectedOptions: [],
        detailAddress: ''
      },
      ruleForm: {
        id: '',
        name: '',
        firstLetter: '',
        brandStoryText: ''
      }
    }
  },
  methods: {
    handleChange (value) {
      console.log(value)
      var provinceCode = CodeToText[value[0]];
      var cityCode = CodeToText[value[1]];
      var orgion = CodeToText[value[2]];
      console.log(provinceCode)
      console.log(cityCode)
      console.log(orgion)
      this.selectedOptions = [value[0], value[1], value[2]]
      this.form.provinceCode = provinceCode
      this.form.cityCode = cityCode
      this.form.orgion = orgion
      console.log(this.form);

    },
    handCancer () {
      this.dialogVisible = false
    },
    // 添加确定提交
    handleSave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //提交地址
          let para = new URLSearchParams()
          para.append('addressName', this.form.addressName)
          para.append('name', this.form.name)
          para.append('phone', this.form.phone)
          para.append('province', this.form.provinceCode)
          para.append('city', this.form.cityCode)
          para.append('region', this.form.orgion)
          para.append('detailAddress', this.form.detailAddress)
          addAddress(para).then(data => {
            console.log(data);
            if (data.code === 10000) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              this.dialogVisible = false
              this.$refs.form.resetFields()
              this.queryBrandList()
            } else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //查看
    handleDetail (index, row) {
      // row 就是当前条目的对象
      // console.log(index, row);
      this.detaildialogVisible = true
      this.detailData = row

    },
    // 编辑点击事件
    handleEdit (index, row) {
      console.log(row);
      this.editDialogVisible = true
      this.ruleForm.id = row.id
      this.ruleForm.name = row.name
      this.ruleForm.firstLetter = row.firstLetter
      this.ruleForm.brandStoryText = row.brandStory
    },
    // 编辑提交
    handleEditSubmit () {
      let para = new URLSearchParams()
      para.append('id', this.ruleForm.id)
      para.append('name', this.ruleForm.name)
      para.append('firstLetter', this.ruleForm.firstLetter)
      para.append('brandStoryText', this.ruleForm.brandStoryText)
      para.append('showStatus', 1)
      updateBrand(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.editDialogVisible = false
          this.queryBrandList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    //删除
    handleDelete (index, row) {
      // row  当前点击条目
      let para = new URLSearchParams()
      para.append("id", row.id)
      deleteAddress(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.queryBrandList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 查询退货地址列表
    queryBrandList () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      //请求接口
      queryListAddress(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.queryBrandList()
    },
  },
  //生命周期
  mounted () {
    this.queryBrandList()
  }
}

</script>
<style lang="stylus">
#goods {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
